"use strict";

require("core-js/modules/es6.array.for-each");

var _toConsumableArray = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var getWindow_1 = tslib_1.__importDefault(require("../dom-utils/getWindow"));

var passive = {
  passive: true
};
/**
 *
 */

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow_1["default"](state.elements.popper);
  var scrollParents = [].concat(_toConsumableArray(state.scrollParents.reference), _toConsumableArray(state.scrollParents.popper));

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
}

exports["default"] = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};